import { Modal as AntModal } from 'antd'

export function DisplayProjectUpdateErrorModal(error: any, status: number) {
  if (error?.response?.status === 403) {
    AntModal.error({
      title: 'Permission denied',
      content: (
        <>
          <p>
            You do not have permission to edit this project. Please check your
            Project permissions in the client portal.
          </p>
          <p>{`Details: ${status}: ${error}`}</p>
        </>
      )
    })
  } else {
    AntModal.error({
      title: 'Error Saving Project',
      content: (
        <>
          <p>Error, you may wish to try again. </p>
          <p>{`Details: ${status}: ${error}`}</p>
          {error?.response?.status === 400 &&
            error?.response?.data?.errors &&
            renderValidationErrors(error.response.data.errors)}
        </>
      )
    })
  }
}

const renderValidationErrors = validationErrors => {
  const keys = Object.keys(validationErrors)
  return (
    <>
      <p style={{ fontWeight: 'bold' }}>Validation Errors:</p>
      {keys.map(k => (
        <>
          <p style={{ textDecoration: 'underline' }}>{k}:</p>
          {validationErrors[k].map(v => (
            <p>{v}</p>
          ))}
        </>
      ))}
    </>
  )
}
